"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _types = require("../utils/types");
var _TierLimits = _interopRequireDefault(require("../TierLimits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var InfoSmall = function InfoSmall(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7-2a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v4h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-4h-1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};
InfoSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var ArrowDownSmall = function ArrowDownSmall(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.293 9.293a1 1 0 0 1 1.414 0l4.288 4.288 4.299-4.289a1 1 0 0 1 1.412 1.416l-4.299 4.29c-.781.78-2.044.78-2.824 0l-4.29-4.29a1 1 0 0 1 0-1.415z"
  }));
};
ArrowDownSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var ArrowUpSmall = function ArrowUpSmall(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.707 15.29a1 1 0 0 1-1.414 0l-4.288-4.288-4.299 4.288a1 1 0 1 1-1.412-1.415l4.3-4.29c.78-.78 2.043-.78 2.823 0l4.29 4.29a1 1 0 0 1 0 1.415z"
  }));
};
ArrowUpSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "warning": "TierPreview__warning__2-Fds",
  "info-icon": "TierPreview__info-icon__3rPN-",
  "infoIcon": "TierPreview__info-icon__3rPN-",
  "tier-preview": "TierPreview__tier-preview__nPAs7",
  "tierPreview": "TierPreview__tier-preview__nPAs7",
  "clickable-title": "TierPreview__clickable-title__3CtAP",
  "clickableTitle": "TierPreview__clickable-title__3CtAP",
  "collapse-icon": "TierPreview__collapse-icon__2Y8I8",
  "collapseIcon": "TierPreview__collapse-icon__2Y8I8",
  "title": "TierPreview__title__2EFx3"
}; 
require('./TierPreview.css');
var TierPreview = /*#__PURE__*/function (_React$PureComponent) {
  function TierPreview(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TierPreview);
    _this = _callSuper(this, TierPreview, [props]);
    (0, _defineProperty2.default)(_this, "handleVisibilityChange", function () {
      var isCollapsed = _this.state.isCollapsed;
      var isCollapsible = _this.props.isCollapsible;
      if (isCollapsible) {
        _this.setState({
          isCollapsed: !isCollapsed
        });
      }
    });
    (0, _defineProperty2.default)(_this, "renderTitleContent", function () {
      var _this$props = _this.props,
        title = _this$props.title,
        isCollapsible = _this$props.isCollapsible;
      var isCollapsed = _this.state.isCollapsed;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title, isCollapsible ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.collapseIcon,
        role: "img",
        size: "xs",
        isExternal: false
      }, isCollapsed ? /*#__PURE__*/_react.default.createElement(ArrowDownSmall, null) : /*#__PURE__*/_react.default.createElement(ArrowUpSmall, null)) : null);
    });
    _this.state = {
      isCollapsed: props.startCollapsed
    };
    return _this;
  }
  (0, _inherits2.default)(TierPreview, _React$PureComponent);
  return (0, _createClass2.default)(TierPreview, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        title = _this$props2.title,
        limits = _this$props2.limits,
        showWarning = _this$props2.showWarning,
        isCollapsible = _this$props2.isCollapsible,
        className = _this$props2.className,
        testId = _this$props2.testId;
      var isCollapsed = this.state.isCollapsed;
      var contentId = 'tier-limits';
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": testId,
        className: (0, _classnames.default)(className, styles.tierPreview)
      }, title && isCollapsible ? /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: (0, _classnames.default)(styles.title, styles.clickableTitle),
        onClick: this.handleVisibilityChange,
        "aria-expanded": !isCollapsed,
        "aria-controls": contentId
      }, this.renderTitleContent()) : null, title && !isCollapsible ? /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.title)
      }, this.renderTitleContent()) : null, !isCollapsed ? /*#__PURE__*/_react.default.createElement("div", {
        id: contentId
      }, /*#__PURE__*/_react.default.createElement(_TierLimits.default, {
        limits: limits,
        testId: testId
      }), showWarning ? /*#__PURE__*/_react.default.createElement("span", {
        className: styles.warning
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.infoIcon,
        role: "img",
        size: "xs",
        isExternal: false,
        "aria-label": "Warning"
      }, /*#__PURE__*/_react.default.createElement(InfoSmall, null)), "This instance currently has higher limits, so these limits will not be applied.") : null) : null);
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(TierPreview, "propTypes", {
  title: _propTypes.default.string,
  limits: _propTypes.default.arrayOf(_types.TierLimitShape).isRequired,
  showWarning: _propTypes.default.bool,
  isCollapsible: _propTypes.default.bool,
  startCollapsed: _propTypes.default.bool,
  className: _propTypes.default.string,
  testId: _propTypes.default.string
});
(0, _defineProperty2.default)(TierPreview, "defaultProps", {
  showWarning: false,
  isCollapsible: false,
  startCollapsed: false,
  testId: 'tier-preview'
});
var _default = exports.default = TierPreview;
//# sourceMappingURL=TierPreview.js.map